import { memo } from "react";
import { useLocation } from "react-router";
import { Tabs, Tab } from "@heroui/react";
import { GearIcon, HouseIcon, ListChecksIcon, NoteIcon } from "@phosphor-icons/react";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";

import { LAYOUT, ROUTES_TO } from "@/config/constants";
import { useBoundStore } from "@/app/store";

function BottomNavigationMobileComponent() {
  const showBottomNavigation = useBoundStore((state) => state.pageLayout.showBottomNavigation);
  const location = useLocation();

  const getActiveTab = () => {
    if (location.pathname.startsWith("/notes")) return "notes";
    if (location.pathname.startsWith(ROUTES_TO.todos)) return "todos";
    if (location.pathname.startsWith(ROUTES_TO.settings)) return "settings";
    return "home";
  };

  return (
    <AnimatePresence>
      {showBottomNavigation && (
        <motion.nav
          style={{
            height: LAYOUT.mobile.bottomNav.height,
            bottom: LAYOUT.mobile.bottomNav.bottom,
            maxHeight: LAYOUT.mobile.bottomNav.height,
          }}
          className="border-default-200 dark:border-default-100 bg-background/80 fixed left-1/2 flex w-[calc(100%-2rem)] max-w-5xl -translate-x-1/2 items-center justify-around rounded-full border p-1 backdrop-blur"
          initial={{ translateY: "100%", opacity: 0 }}
          animate={{ translateY: "0%", opacity: 1 }}
          exit={{ translateY: "100%", opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <Tabs
            selectedKey={getActiveTab()}
            classNames={{
              tabList: "bg-transparent",
              tab: clsx("h-12", "data-[selected]:bg-content2"),
              cursor: "bg-content2!",
            }}
            fullWidth
            radius="full"
          >
            <Tab
              key="home"
              title={
                <div className="flex items-center gap-2 py-1">
                  <HouseIcon size={24} />
                </div>
              }
              href={ROUTES_TO.home}
              routerOptions={{ replace: true }}
            />
            <Tab
              key="notes"
              title={
                <div className="flex items-center gap-2">
                  <NoteIcon size={24} />
                </div>
              }
              href={ROUTES_TO.notes}
              routerOptions={{ replace: true }}
            />
            <Tab
              key="todos"
              title={
                <div className="flex items-center gap-2">
                  <ListChecksIcon size={24} />
                </div>
              }
              href={ROUTES_TO.todos}
              routerOptions={{ replace: true }}
            />
            <Tab
              key="settings"
              title={
                <div className="flex items-center gap-2">
                  <GearIcon size={24} />
                </div>
              }
              href={ROUTES_TO.settings}
              routerOptions={{ replace: true }}
            />
          </Tabs>
        </motion.nav>
      )}
    </AnimatePresence>
  );
}

export const BottomNavigationMobile = memo(BottomNavigationMobileComponent);
